import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PropertyUpdatePMId } from "../../Services/Service";

// async thunk
export const PropUpdatePMS = createAsyncThunk(
    "pms/updatePMS",
    async ({ BONRESID, PMSRESID }, { rejectWithValue }) => {
        try {
            const response = await PropertyUpdatePMId(
                BONRESID,
                PMSRESID
            );
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error updating PMS");
        }
    }
);

const propPmsSlice = createSlice({
    name: "pms",
    initialState: {
        loading: false,
        success: false,
        error: null,
    },
    reducers: {
        PropresetPMSState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(PropUpdatePMS.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(PropUpdatePMS.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(PropUpdatePMS.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { PropresetPMSState } = propPmsSlice.actions;
export default propPmsSlice.reducer;